const common = {
  message: {
    failureMessageUpload: 'Er is iets misgegaan, probeer het alsjeblieft nog eens.'
  }
};

export default common;
